<template>
    <div class="sceditor">
        <textarea ref="editortextarea" rows="16" />
    </div>
</template>

<script>
    import editorHelper from '../../modules/postEditor'
    //import api from '../../api/api';
    import settings from "../../modules/settings";
    //import dialogs from '../../modules/dialogs'


    // instance of the sceditor, applied on mount() when it's created
    let instance = null;

    export default {        
        props: ['bindKey'],
        data() {
            return {
            };
        },
        methods: {
            pickSuggestion() {},
          /*
            pickSuggestion(suggestion, state) {
              
                let oldVal = instance.getBody().innerHTML;
                const insertion = '<span class="mention-code" contenteditable=false>@' + suggestion + '</span> ';
                const newVal = oldVal.replace('@' + state, insertion);
                this.setValue(newVal);
                
            },
            */
            nodeChanged() {
                this.$emit("nodeChanged");
            },
            editorKeyDown(ev) {
                if (((ev.keyCode >= 9 && ev.keyCode <= 45) || (ev.keyCode >= 91 || ev.keyCode <= 93) || (ev.keyCode >= 112 || ev.keyCode <= 145))) {
                    if(ev.key.length == 1 || ev.key == "Backspace" || ev.key == "Tab"){
                        this.$emit("editorKeyDown", ev);
                    }
                }
            },
            getValue: function() {
                instance.toggleSourceMode();
                let content = instance.getBody().innerHTML;
                if (instance.inSourceMode()){
                  instance.toggleSourceMode();
                }
                return content;
            },            
            setValue: function(content) {
                instance.val(content, false);
            },
            setUpEditor() {
              // eslint-disable-next-line
              sceditor.formats.bbcode.set('url', {
                tags: {
                    "a": {
                        "download": null,
                        "href": null,
                    }
                },
                isSelfClosing: false,
                isInline: true,
                isHtmlInline: true,
                allowedChildren: null,
                allowsEmpty: false,
                excludeClosing: false,
                skipLastLineBreak: false,

                breakBefore: false,
                breakStart: false,
                breakEnd: false,
                breakAfter: false,
                // eslint-disable-next-line
                format: function(element, content) {
                  return `[url=${element.href}]${element.innerHTML}[/url]`
                },
                html: function(token, attrs, content) {
                  if(typeof attrs.defaultattr !== 'undefined' && attrs.defaultattr.endsWith('download'))
                    return `<a target="_blank" href="${attrs.defaultattr.substring(0, attrs.defaultattr.length - 9)}" download> ${content} </a>`
                  return `<a target="_blank" href="${attrs.defaultattr}"> ${content} </a>`
                },
                // eslint-disable-next-line
                quoteType: sceditor.BBCodeParser.QuoteType.auto
              })
            },
            getSCEditInstance() {
              return instance;
            }
        },
        mounted() {
            let textarea = this.$refs.editortextarea;
            this.setUpEditor();
            editorHelper.editorConfig.emoticonsEnabled = settings.user.getUseEmoticons();
            // eslint-disable-next-line
            sceditor.create(textarea, editorHelper.editorConfig);
            // eslint-disable-next-line
            instance = sceditor.instance(textarea);
            var adjusted = (parseInt((window.getComputedStyle(instance.getContentAreaContainer()).height).replace('px',''))-37)+'px';
            instance.getBody().style.height = adjusted;
            if(this.bindKey) {
                instance.keyDown(this.editorKeyDown);
                instance.bind("nodechanged", this.nodeChanged)
            }
            var x = document.getElementsByTagName("iframe")[0].contentWindow;
            x.document.body.onmousedown = () => {
              this.$emit("nodeChanged");
            }
        }
    }

</script>